import { Metadata } from 'next';
import logoImg from '@public/images/logo.png';
import { OpenGraph } from 'next/dist/lib/metadata/types/opengraph-types';
import { LAYOUT_OPTIONS } from './enums';

enum MODE {
  DARK = 'dark',
  LIGHT = 'light',
}

export const siteConfig = {
  title: '',
  description: ``,
  logo: logoImg,
  mode: MODE.LIGHT,
  layout: LAYOUT_OPTIONS.HYDROGEN,
  // TODO: favicon
};

export const metaObject = (title?: string, openGraph?: OpenGraph, description: string = siteConfig.description): Metadata => {
  return {
    title: title ? `${title}` : siteConfig.title,
    description,
    openGraph: openGraph ?? {
      title: title ? `${title}` : title,
      description,
      url: '',
      siteName: 'mypark', // https://developers.google.com/search/docs/appearance/site-names
      images: {
        url: '',
        width: 1200,
        height: 630,
      },
      locale: 'ko_KR',
      type: 'website',
    },
  };
};
